import { create } from "zustand";
import { CartState } from "@/app/store";

export interface CartStore {
	readonly cartState: CartState;
	setCartState: (cartState: CartState) => void;
	getCartCount: () => number | undefined;
}

export const useCartStore = create<CartStore>((set, get) => {
	return {
		cartState: {
			status: "not-connected"
		},

		setCartState: (cartState: CartState): void => {
			set({ cartState });
		},

		getCartCount(): number {
			const cartState = get().cartState;

			if (cartState.status === "not-connected") {
				return 0;
			}

			return cartState.entries.reduce(
				(acc, product) => acc + product.quantity,
				0
			);
		}
	};
});
